/**
 * User-facing message for a failed correction call. The backend's own 403/422
 * text is already Spanish and specific (authority before state, R16), so it
 * is shown as-is; a 409 means a stale lock_version and needs a reload.
 */
export function correctionErrorMessage(err: unknown, record: string): string {
  const response = (err as { response?: { status?: number; data?: { message?: string } } })?.response;
  if (response?.status === 409) {
    return `Otro usuario modificó ${record}. Recargue la página antes de continuar.`;
  }
  return response?.data?.message || `No se pudo guardar ${record}. Intente de nuevo.`;
}
